export enum ELight {
    Green = 10,
    GreenWarning = 11,
    None = 20,
    Yellow = 30,
    Red = 40
}